// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calendar-selection[data-v-1ac610e9]{align-items:baseline;display:flex;justify-content:space-between}.calendar-selection__back-button[data-v-1ac610e9]{color:currentColor;font-size:1.5em;line-height:1em}.calendar-selection__back-button[data-v-1ac610e9]:hover{color:currentColor}.calendar-selection__text[data-v-1ac610e9]{font-style:italic;margin-bottom:0}.calendar-selection__date[data-v-1ac610e9]{font-style:normal;margin-left:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
